import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"

/**
 * Get schedules matching the filters
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getSchedules = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  const response = await fetch(
    `${API_BASE_URL}/api/schedules?${params.toString()}`
  )
  if (!response.ok) {
    throw new Error(
      `HTTP error ${response.status} received when calling the getSchedules service.`
    )
  }

  return response.json()
}

/**
 * Get a schedule by Id
 * @param scheduleId
 * @returns {Promise<any>}
 */
export const getScheduleById = async (scheduleId) => {
  const response = await fetch(
    `http://20.0.0.3/synapse/api/schedule/${scheduleId}`
  )
  if (!response.ok) {
    throw new Error(
      `HTTP error ${response.status} received when the getScheduleById service.`
    )
  }

  return response.json()
}
